import { call, put } from 'redux-saga/effects';
import { BACKEND_URL } from '../../../configs';
import makeRequest from '../../../utils/makeRequest';
import { OK } from '../../../configs/serverStatusCodes';
import { historyExportWordFailed, historyExportWordSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import processError from '../../../utils/processError';

export default function* historyExportWord(action) {
  try {
    const {
      payload: {
        filter,
      } = {},
    } = action;
    const pool = {};
    filter.type = 1;
    if (filter && Object.keys(filter).length) {
      pool.filter = filter;
    }
    const url = `${BACKEND_URL}/host-statuses/history/export/word`;
    const dataResponse = yield makeRequest(url, pool, action, 'POST');
    const responseJson = yield dataResponse.json();
    if (dataResponse && dataResponse.status === OK && responseJson) {
      yield put(historyExportWordSuccessful(responseJson.result));
      yield call(resolveActionPromise(action, responseJson.result));
    } else {
      yield put(historyExportWordFailed(responseJson));
      yield call(rejectActionPromise(action, responseJson));
    }
  } catch (e) {
    yield put(historyExportWordFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
